import React from "react";
import { Box, Typography, Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { accountsmanagement } from "../../../config";
// *** NEW: Import router hooks to read ID from URL ***
import { useParams, useLocation } from 'react-router-dom';

// NOTE: You need to create an array of columns that contains ONLY the fields you want to show.
import { allRelievers } from "../../../data/Columns/hrmanagement"; 

// *** FIX: Import 'allUsersQuery' to resolve the 'relieversQuery' error ***
// If you create a specific query later (e.g., allProformaRelieversQuery), update this.
import { allUsersQuery } from "../../../data/Axios/queries"; 
import CreditNoteEntryForm from "./form";
import CreditNoteLinesForm from "./CreditNoteLinesForm";
import { CreditNoteLinesColumns} from "../../../data/DynamicTable/Collumns";
import { useNavigate } from "react-router-dom";

const base_url = accountsmanagement.uri;
function CreditNoteLines() {
    const location = useLocation();
    const data = 
      location.state?.creditNoteData ||
      JSON.parse(localStorage.getItem("MyCreditNoteData"));

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();

    const handleGoBack = () => {
      const backPath = location.state?.from || "/CreditNote";
      navigate(backPath);
    };
// Define actions for a simple view-only relievers list (unchanged)
const actions = React.useMemo(() => ({
  entity: "Credit Note Lines",
  required: "id",
  edit: {
    key: "EDIT",
    button_name: "Edit Credit Note Lines",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  add: {
    key: "ADD",
    button_name: "Add Credit Note Lines",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: false,
  modelName: "allCreditNotesLinesByCreditId",
  dataObject: {
    inputFields: {
      creditNoteId: data?.id,
    },
    inputObjectName: "allCreditNotesLinesByCreditId",
    inputSubObjectName: "creditNotesLines",
    returnFields: [
      "id",
      "creditNoteId",
      "description",
      "accountSubCategoryId",
      "accountSubCategoryName",
      "amount",
      "vatId",
      "vatAmount",
      "isActive",
      // "createdBy",
      // "createdDate",
      // "updatedBy",
      // "updatedDate",
    ],
  },
}), [data?.id]);

const title = `Credit Note Lines`;

  const subtitle = `View All Lines`;

  return (
    <Box m="2px" p="1rem">
        {/* Floating Back Button */}
        <Fab
          color="secondary"
          aria-label="go back"
          onClick={handleGoBack}
          sx={{
            position: "fixed",
            top: 120,      
            left: 270,     
            zIndex: 1100,
            width: 40,
            height: 40,
            boxShadow: 3,
            "&:hover": {
              boxShadow: 6,
            },
          }}
        >
          <ArrowBackIcon />
        </Fab>

      <DynamicTable
        title={title}
        subtitle={subtitle}
        columns={CreditNoteLinesColumns}
        FormComponent={CreditNoteLinesForm}
        //query={allCasesView}
        base_url={base_url}
        actions={actions}
      />
      {/* //)} */}
    </Box>
  );


    
    

}
export default CreditNoteLines;